import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { courseResults } from '../../../mocks/courseModules';

function useCountdown() {
  const getTargetDate = () => {
    const stored = localStorage.getItem('via_offer_end');
    if (stored) {
      const date = new Date(stored);
      if (date.getTime() > Date.now()) return date;
    }
    const target = new Date();
    target.setDate(target.getDate() + 3);
    target.setHours(23, 59, 59, 0);
    localStorage.setItem('via_offer_end', target.toISOString());
    return target;
  };

  const [targetDate] = useState(getTargetDate);
  const [timeLeft, setTimeLeft] = useState({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    const calc = () => {
      const diff = Math.max(0, targetDate.getTime() - Date.now());
      setTimeLeft({
        days: Math.floor(diff / (1000 * 60 * 60 * 24)),
        hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((diff / (1000 * 60)) % 60),
        seconds: Math.floor((diff / 1000) % 60),
      });
    };
    calc();
    const id = setInterval(calc, 1000);
    return () => clearInterval(id);
  }, [targetDate]);

  return timeLeft;
}

export default function CourseHero() {
  const { days, hours, minutes, seconds } = useCountdown();
  const navigate = useNavigate();
  const blocks = [
    { value: days, label: 'Dias' },
    { value: hours, label: 'Horas' },
    { value: minutes, label: 'Min' },
    { value: seconds, label: 'Seg' },
  ];

  const scrollToModules = () => {
    document.getElementById('modulos')?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleCheckoutClick = () => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      (window as any).fbq('track', 'AddToCart', {
        value: 147.00,
        currency: 'BRL',
        content_name: 'Curso ChatGPT e Gemini para Professores',
        content_ids: ['curso-chatgpt-gemini'],
        content_type: 'product',
        num_items: 1,
      });
      (window as any).fbq('track', 'InitiateCheckout', {
        value: 147.00,
        currency: 'BRL',
        content_name: 'Curso ChatGPT e Gemini para Professores',
        content_ids: ['curso-chatgpt-gemini'],
        content_type: 'product',
        num_items: 1,
      });
    }
    window.open('https://pay.hotmart.com/W100719375C?checkoutMode=10&bid=1774715641981', '_blank', 'noopener,noreferrer');
  };

  return (
    <section className="relative pt-20 overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: 'url(https://public.readdy.ai/ai/img_res/0a518fd374a82ead27cf934974d293c3.jpg)'
        }}
      >
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/60"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 py-24 lg:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <div className="inline-flex items-center gap-2 px-4 py-2 bg-orange-500/20 border border-orange-400/40 rounded-full mb-6">
              <i className="ri-fire-fill text-orange-400 text-sm w-4 h-4 flex items-center justify-center"></i>
              <span className="text-orange-300 text-sm font-semibold">MAIS VENDIDO — Oferta Especial</span>
            </div>

            <h1 className="text-4xl lg:text-5xl font-bold text-white leading-tight mb-6">
              Curso Completo: IA para professores <br />
              <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-400 to-amber-300">
                + CENTRAL PEDAGÓGICA
              </span>{' '}
              com assistentes de IA
            </h1>

            <p className="text-lg text-gray-200 leading-relaxed mb-8 max-w-xl">
              Domine a Inteligência Artificial de forma prática e intencional. 8 módulos completos, materiais prontos e 3 agentes de IA exclusivos como bônus.
            </p>

            <div className="flex items-center gap-4 mb-8">
              <div className="flex items-baseline gap-2">
                <span className="text-5xl font-bold text-white">R$ 147,00</span>
              </div>
            </div>

            <div className="flex flex-wrap gap-4 mb-10">
              <button
                onClick={handleCheckoutClick}
                className="inline-flex items-center gap-2 px-8 py-4 bg-gradient-to-r from-orange-500 to-amber-500 text-white font-bold rounded-full hover:shadow-2xl hover:scale-105 transition-all duration-300 whitespace-nowrap animate-pulse cursor-pointer"
              >
                <i className="ri-shopping-cart-2-fill text-lg"></i>
                Quero me Inscrever
              </button>

            </div>

            {/* Selo de Garantia */}
            <div className="inline-flex items-center gap-4 bg-white/10 backdrop-blur-sm border border-white/25 rounded-2xl px-5 py-4">
              <div className="w-14 h-14 flex items-center justify-center bg-green-500/20 border-2 border-green-400/60 rounded-full flex-shrink-0">
                <i className="ri-shield-check-fill text-green-400 text-2xl w-6 h-6 flex items-center justify-center"></i>
              </div>
              <div>
                <p className="text-white font-bold text-sm leading-tight">Garantia Incondicional de 15 Dias</p>
                <p className="text-gray-300 text-xs mt-0.5 leading-snug">Não gostou? Devolvemos 100% do seu dinheiro,<br />sem perguntas.</p>
              </div>
            </div>
          </div>

          <div className="hidden lg:block">
            <div className="relative">
              <img
                src="https://readdy.ai/api/search-image?query=professional%20female%20teacher%20smiling%20confidently%20holding%20tablet%20showing%20ai%20interface%20modern%20bright%20classroom%20setting%20warm%20natural%20lighting%20clean%20background%20educational%20technology%20atmosphere%20inspiring%20professional%20photography&width=700&height=850&seq=coursedetail002&orientation=portrait"
                alt="Professora usando IA na educação"
                className="rounded-3xl shadow-2xl w-full h-[520px] object-cover object-top"
              />
              <div className="absolute -bottom-6 -left-6 bg-white rounded-2xl shadow-xl p-4 flex items-center gap-3">
                <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center">
                  <i className="ri-user-star-fill text-green-600 text-xl"></i>
                </div>
                <div>
                  <p className="text-sm font-bold text-gray-900">500+ professores</p>
                  <p className="text-xs text-gray-500">já transformaram suas aulas</p>
                </div>
              </div>
              <div className="absolute -top-4 -right-4 bg-white rounded-2xl shadow-xl p-4 flex items-center gap-3">
                <div className="w-12 h-12 bg-amber-100 rounded-full flex items-center justify-center">
                  <i className="ri-star-fill text-amber-500 text-xl"></i>
                </div>
                <div>
                  <p className="text-sm font-bold text-gray-900">4.9/5.0</p>
                  <p className="text-xs text-gray-500">avaliação dos alunos</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-6 mt-16">
          {courseResults.map((item, index) => (
            <div key={index} className="text-center bg-white/10 backdrop-blur-sm rounded-2xl p-5 border border-white/15">
              <p className="text-3xl font-bold text-white mb-1">{item.number}</p>
              <p className="text-sm text-gray-300">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
